<template>
  <div id="app">
    <div>
      <TopNav
        @loadding="loaddingChage"
        @loaddingOut="loaddingOut"
        @refresh="refresh"
        @joinUsList="joinUsList"
      />
      <router-view
        v-slot="{ Component }"
        :imageList="imageList"
        @refresh="refresh"
        :widthLine="widthLine"
        :moveDataList="moveDataList"
        :marginLeft="marginLeft"
        @handleScrollMove="handleScrollMove"
        @handleScrollDrawer="handleScrollDrawer"
        @windowScool="windowScool"
        @joinUsList="joinUsListAbout"
        @mouseoveradressover="mouseoveradressover"
        @mouseleaveadressLeave="mouseleaveadressLeave"
      >
        <component :is="Component" />
      </router-view>
      <footerView @refresh="refresh" />
      <loadding :show="show" />
    </div>
    <dialogView
      :rules="rules"
      :form="form"
      :type="'其他'"
      :dialogVisible="dialogVisibleOther"
      @closeWindow="closeWindow"
      :title="'产品试用'"
    />
    <dialogView
      :rules="rulesJoin"
      :form="formJoin"
      :type="'关于我们'"
      :dialogVisible="dialogVisibleJoin"
      @closeWindow="closeWindowJoin"
      :title="'加入我们'"
    />
  </div>
</template>

<script>
import TopNav from "./public/TopNav";
import loadding from "./public/loadding";
import footerView from "./public/footer";
import dialogView from "./public/dialog";
export default {
  name: "App",
  components: {
    TopNav,
    footerView,
    loadding,
    dialogView
  },
  data() {
    return {
      rulesJoin: {
        people: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        tel: [
          {
            required: true,
            message: "请输入联系人电话",
            trigger: "blur"
          }
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        emai: [
          {
            required: true,
            message: "请输入电子邮件",
            trigger: "blur"
          }
        ],
        text: [
          {
            required: true,
            message: "请输入需求内容",
            trigger: "blur"
          }
        ]
      },
      formJoin: {
        people: "",
        tel: "",
        code: "",
        emai: "",
        text: "",
        checked: false
      },
      dialogVisibleJoin: false,
      rules: {
        people: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        tel: [
          {
            required: true,
            message: "请输入联系人电话",
            trigger: "blur"
          }
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        emai: [
          {
            required: true,
            message: "请输入电子邮件",
            trigger: "blur"
          }
        ],
        text: [
          {
            required: true,
            message: "请输入需求内容",
            trigger: "blur"
          }
        ],
        company: [
          {
            required: true,
            message: "请输入企业名称",
            trigger: "blur"
          }
        ]
      },
      form: {
        people: "",
        tel: "",
        code: "",
        emai: "",
        text: "",
        company: "",
        checked: false
      },
      stepNum: 0,
      dialogVisible: false,
      dialogVisibleOther: false,
      drawerRefHeight: 0,
      moveHeight: 0,
      drawerRef: 0,
      loginImageRef: 0,
      handleScrollLeft: 0,
      moveLineRef: 0,
      marginLeft: 0,
      widthLine: 0,
      show: false,
      scollYNum: 0,
      moveDataList: [
        {
          direction: "up",
          leftLength: 0,
          url: require("./assets/image/page/links/link1.png"),
          text: "产品生产",
          sumbile: "Production",
          show: false
        },
        {
          direction: "bottom",
          leftLength: 0,
          url: require("./assets/image/page/links/link2.png"),
          text: "产品生产1",
          sumbile: "Production1",
          show: false
        },
        {
          direction: "up",
          leftLength: 0,
          url: require("./assets/image/page/links/link3.png"),
          text: "产品生产2",
          sumbile: "Production2",
          show: false
        },
        {
          direction: "bottom",
          leftLength: 0,
          url: require("./assets/image/page/links/link4.png"),
          text: "产品生产3",
          sumbile: "Production3",
          show: false
        }
      ],
      imageList: [
        {
          url: require("./assets/image/page/drawer/drawer1.png"),
          top: 0,
          size: "100%",
          name: "firm"
        },
        {
          url: require("./assets/image/page/drawer/drawer2.png"),
          top: 1040,
          size: "100%",
          name: "/wenBo"
        },
        {
          url: require("./assets/image/page/drawer/drawer3.png"),
          top: 1040,
          size: "100%",
          name: "wenBo"
        },
        {
          url: require("./assets/image/page/drawer/drawer4.png"),
          top: 1040,
          size: "100%",
          name: "hotel"
        }
      ],
      adewssSshow: false
    };
  },
  created() {},
  mounted() {
    sessionStorage.setItem("windowShow", 1);
    window.addEventListener("mousewheel", this.handleMouseWheel, {
      passive: false
    });
  },
  beforeDestroy() {
    window.removeEventListener("mousewheel", this.handleMouseWheel, false);
  },
  methods: {
    closeWindowJoin() {
      this.dialogVisibleJoin = false;
      this.show = false;
      sessionStorage.setItem("windowShow", 1);
    },
    closeWindow() {
      this.dialogVisibleOther = false;
      this.show = false;
      sessionStorage.setItem("windowShow", 1);
    },
    joinUsListAbout() {
      this.dialogVisibleJoin = true;
      this.show = true;
      sessionStorage.setItem("windowShow", 2);
    },
    joinUsList() {
      this.dialogVisibleOther = true;
      this.show = true;
      sessionStorage.setItem("windowShow", 2);
    },
    windowScool(val) {
      this.scollYNum = val * 1;
    },
    refresh() {
      this.stepNum = 0;
      this.scollYNum = 0;
      document.documentElement.scrollTop = 0;
      this.widthLine = 0;
      this.marginLeft = 0;
      this.imageList = [
        {
          url: require("./assets/image/page/drawer/drawer1.png"),
          top: 0,
          size: "100%"
        },
        {
          url: require("./assets/image/page/drawer/drawer2.png"),
          top: 1040,
          size: "100%"
        },
        {
          url: require("./assets/image/page/drawer/drawer3.png"),
          top: 1040,
          size: "100%"
        },
        {
          url: require("./assets/image/page/drawer/drawer4.png"),
          top: 1040,
          size: "100%"
        }
      ];
      this.moveDataList = [
        {
          direction: "up",
          leftLength: 0,
          url: require("./assets/image/page/links/link1.png"),
          show: false
        },
        {
          direction: "bottom",
          leftLength: 0,
          url: require("./assets/image/page/links/link2.png"),
          show: false
        },
        {
          direction: "up",
          leftLength: 0,
          url: require("./assets/image/page/links/link3.png"),
          show: false
        },
        {
          direction: "bottom",
          leftLength: 0,
          url: require("./assets/image/page/links/link4.png"),
          show: false
        }
      ];
    },
    handleScrollMove(val) {
      this.moveLineRef = val.handleScroll;
      this.moveHeight = val.height;
    },
    handleScrollLogin(val) {
      this.handleScrollLeft = val.handleScroll;
      this.loginImageRef = val.loginImageRef;
    },
    handleScrollDrawer(val) {
      this.drawerRef = val.drawerRef;
      this.drawerRefHeight = val.height;
    },
    handleMouseWheel(e) {
      this.scollYNum = this.scollYNum < 0 ? 0 : this.scollYNum;
      if (this.scollYNum >= 0) {
        const drawerRef = this.drawerRef;
        const moveLineRef = this.moveLineRef;
        const windowShow = sessionStorage.getItem("windowShow");
        if (windowShow != "2") {
          if (e.wheelDelta) {
            // 判断浏览器IE，谷歌滑轮事件
            if (e.wheelDelta < 0) {
              sessionStorage.setItem("isScollo", true);
              if (this.$route.name == "HomePage") {
                if (
                  this.scollYNum.toString().length ==
                    drawerRef.toString().length &&
                  this.scollYNum.toString().slice(0, 2) ==
                    (drawerRef - 100).toString().slice(0, 2)
                ) {
                  if (this.stepNum == 0) {
                    this.imageList[0].size = "60%";
                  } else if (this.stepNum == 1) {
                    this.imageList[1].top = 40;
                  } else if (this.stepNum == 2) {
                    this.imageList[1].size = "70%";
                  } else if (this.stepNum == 3) {
                    this.imageList[2].top = 90;
                  } else if (this.stepNum == 4) {
                    this.imageList[2].size = "80%";
                  } else if (this.stepNum == 5) {
                    this.imageList[3].top = 140;
                  } else if (this.stepNum == 6) {
                    this.imageList[3].size = "90%";
                  } else if (this.stepNum == 7) {
                    this.scollYNum += 100;
                  }
                  if (this.stepNum < 7) {
                    this.stepNum += 1;
                  }
                  //首页解决方案向下滚动
                  // if (this.imageList[1].top > 40) {
                  //   this.imageList[0].size = "60%";
                  //   this.imageList[1].top -= 50;
                  // } else if (
                  //   this.imageList[1].top <= 40 &&
                  //   this.imageList[2].top > 90
                  // ) {
                  //   this.imageList[1].size = "70%";
                  //   this.imageList[2].top -= 50;
                  // } else if (
                  //   this.imageList[2].top <= 90 &&
                  //   this.imageList[3].top > 140
                  // ) {
                  //   this.imageList[2].size = "80%";
                  //   this.imageList[3].top -= 50;
                  //   this.imageList[2].isOk = true;
                  //   if (this.imageList[3].top == 140) {
                  //     this.imageList[3].size = "90%";
                  //   }
                  // } else {
                  //   this.scollYNum += 100;
                  // }
                } else if (
                  this.scollYNum.toString().length ==
                    moveLineRef.toString().length &&
                  this.scollYNum.toString().slice(0, 2) ==
                    (moveLineRef - 100).toString().slice(0, 2)
                ) {
                  //首页高校流程向下滚动
                  if (this.widthLine == this.moveDataList.length * 600 + 200) {
                    this.widthLine == this.moveDataList.length * 600 + 200;
                    this.scollYNum += 100;
                  } else {
                    this.widthLine += 100;
                    this.moveDataList.map((i, index) => {
                      i.leftLength = index * 600 + 100;
                      if (i.leftLength + 200 == this.widthLine) {
                        i.show = true;
                      }
                    });
                    if (this.moveDataList[0].show) {
                      this.marginLeft -= 50;
                    }
                  }
                } else {
                  this.scollYNum += 100;
                }
              } else {
                if (this.$route.name == "aboutUs") {
                  if (!this.adewssSshow) {
                    this.scollYNum += 30;
                  }
                } else {
                  this.scollYNum += 100;
                }
              }
            }
            if (e.wheelDelta > 0) {
              sessionStorage.setItem("isScollo", false);
              if (this.$route.name == "HomePage") {
                if (
                  this.scollYNum.toString().length ==
                    drawerRef.toString().length &&
                  this.scollYNum.toString().slice(0, 2) ==
                    (drawerRef - 100).toString().slice(0, 2)
                ) {
                  //首页解决发难向上滚动
                  if (this.stepNum == 7) {
                    this.imageList[3].size = "100%";
                  } else if (this.stepNum == 6) {
                    this.imageList[3].top = 1040;
                  } else if (this.stepNum == 5) {
                    this.imageList[2].size = "100%";
                  } else if (this.stepNum == 4) {
                    this.imageList[2].top = 1040;
                  } else if (this.stepNum == 3) {
                    this.imageList[1].size = "100%";
                  } else if (this.stepNum == 2) {
                    this.imageList[1].top = 1040;
                  } else if (this.stepNum == 1) {
                    this.imageList[0].size = "100%";
                  } else if (this.stepNum == 0) {
                    this.scollYNum -= 100;
                  }
                  if (this.stepNum > 0) {
                    this.stepNum -= 1;
                  }

                  // if (
                  //   this.imageList[3].top >= 140 &&
                  //   this.imageList[3].top <= 1040
                  // ) {
                  //   this.imageList[3].top += 50;
                  //   this.imageList[3].size = "100%";
                  //   if (this.imageList[3].top >= 1040) {
                  //     this.imageList[2].size = "100%";
                  //   }
                  // } else if (
                  //   this.imageList[2].top >= 90 &&
                  //   this.imageList[2].top <= 1040
                  // ) {
                  //   this.imageList[2].top += 50;
                  //   if (this.imageList[2].top >= 1040) {
                  //     this.imageList[1].size = "100%";
                  //   }
                  // } else if (
                  //   this.imageList[1].top >= 40 &&
                  //   this.imageList[1].top <= 1040
                  // ) {
                  //   this.imageList[1].top += 50;
                  //   if (this.imageList[1].top >= 1040) {
                  //     this.imageList[0].size = "100%";
                  //   }
                  // } else {
                  //   this.scollYNum -= 100;
                  // }
                } else if (
                  this.scollYNum.toString().length ==
                    moveLineRef.toString().length &&
                  this.scollYNum.toString().slice(0, 2) ==
                    (moveLineRef - 100).toString().slice(0, 2)
                ) {
                  //首页高校流程向上滚动
                  if (this.widthLine <= this.moveDataList.length * 600 + 200) {
                    this.widthLine -= 100;
                    this.moveDataList.map((i, index) => {
                      if (i.leftLength + 200 == this.widthLine) {
                        i.show = false;
                      }
                    });

                    this.marginLeft += 50;

                    if (this.widthLine == 0) {
                      this.scollYNum -= 100;
                    }
                  }
                } else {
                  this.scollYNum -= 100;
                }
              } else {
                if (this.$route.name == "aboutUs") {
                  if (!this.adewssSshow) {
                    this.scollYNum -= 30;
                  }
                } else {
                  this.scollYNum -= 100;
                }
              }
            }
            document.documentElement.scrollTop = this.scollYNum;
          }
        }
      }
    },
    mouseoveradressover() {
      this.adewssSshow = true;
    },
    mouseleaveadressLeave() {
      this.adewssSshow = false;
    },
    loaddingOut() {
      if (sessionStorage.getItem("windowShow") == "1") {
        this.show = false;
      }
    },
    loaddingChage() {
      this.show = true;
    }
  }
};
</script>

<style>
body {
  overflow-y: hidden;
}
* {
  padding: 0;
  margin: 0;
}
ul {
  list-style-type: none;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue